document.addEventListener('alpine:init', () => {
    Alpine.data('modal', () => ({
        open: false,
        title: 'Modal Title',
        message: 'Some dialogue or message here',
        label: 'my stuff',
        form: 'testID',
        openModal() {
            this.open = true
        },
        closeModal() {
            this.open = false
        },
        deleteAccount() {
            this.title = 'Are you sure you want to delete your account?'
            this.message = 'Please take note that when your account is deleted all of your memories will be deleted as well.'
            this.label = 'my account'
            this.form = 'delete-account'
            this.open = true
        },
        deleteMemory() {
            this.title = 'Are you sure you want to delete this memory?'
            this.message = 'Once a memory is deleted, it can not be restored.'
            this.label = 'this memory'
            this.form = 'delete-memory'
            this.open = true
        },
    }))
})
